var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Link from "next/link";
export const Crumb = (_a) => {
    var { as: Wrapper, crumb, disabled = false } = _a, props = __rest(_a, ["as", "crumb", "disabled"]);
    const { label, path, icon } = crumb;
    let content = (_jsxs(_Fragment, { children: [icon, _jsx("span", { children: label })] }));
    content =
        path != null && !disabled ? (_jsx(Link, { href: path, children: content })) : (_jsx("div", { children: content }));
    return _jsx(Wrapper, Object.assign({}, props, { children: content }));
};
//# sourceMappingURL=Crumb.js.map